import { createGenericSlice } from '../../../../../utils/slices'

export const girderSlice = createGenericSlice({
  name: 'girder',
  initialState: {
    type: 'solidSawn',
    material: 5,
    width: '2x',
    depth: 6,
    ply: 1,
    topChord: 0,
    topChordPly: 0,
    kingWidth: 0,
    kingHeight: 24,
    memberID: 'Girder 1',
  },
})

export const girderActions = girderSlice.actions
